<template>
    <div class="app-container">
          <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
            <el-form-item label="名称" prop="sName">
              <el-input
                  v-model="queryParams.sName"
                  placeholder="请输入名称"
                  clearable
                  @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table v-loading="loading" :data="tableList" @selection-change="handleSelectionChange">
            <el-table-column label="ID" align="center" prop="id" />
            <el-table-column label="平台号名称" align="center" prop="name" />
            <el-table-column label="操作时间" align="center" prop="createTime" />
            <el-table-column label="操作用户" align="center" prop="director" />
            <el-table-column label="操作详情" align="center" prop="director" />
            <el-table-column label="" align="center" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="text"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>

    </div>
</template>

<script>
export default {
  name: "Log",
  data() {
    return {
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,

      // 简历表格数据
      tableList: [],




      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        code: undefined,
        sName: undefined,
        status: undefined,
        verified: undefined,
        deptId: undefined
      },
      // 表单参数
      form: {},

    };
  },

  created() {

  },
  methods: {
    // 取消按钮
    cancel() {
      this.open = false;
    },


    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true;
      this.title = "添加信息";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      const id = row.id || this.ids
      this.open = true;
      this.title = "修改信息";
    }
  }
}
</script>

<style scoped>

</style>